<template>
    <div class="create-company-container w-100 ">
        <div class="mt-3 px-17" >
            <div class="create-company-header d-flex align-items-center justify-content-between">
                <span class="fs-14 text-white ml-1 fw-500">Add Template Details</span>
            </div>
            <div class="mt-5 w-100 h-line">
                <span class="bg-white h-label">Info</span>
            </div>
            <div class="row mt-7">
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="d-flex align-items-center">
                        <div class="w-100">
                            <span class="input-label">Product Name<sup class="fs-14 pl-1 text-danger">*</sup></span>
                            <div class="d-flex align-content-center mt-2">
                                <input type="text" name="product_name" v-validate="'required'" class="input-field input-width"  v-model="product_name" placeholder="Enter Product Name" />
                            </div>
                            <div class="text-right mt-1">
                                <span class="input-field-length float-right">{{ product_name.length }}/30</span>
                                <span class="float-left text-danger mb-3" v-show="errors.has('product_name')">Product Name is Required</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="d-flex align-items-center">
                        <div class="w-100">
                            <span class="input-label">Headline of URL</span>
                            <div class="d-flex align-content-center mt-2">
                                <input type="text" name="headline_url"  class="input-field input-width"  v-model="headline_url" placeholder="Enter URL Headline" />
                            </div>
                            <div class="text-right mt-1">
                                <span class="input-field-length float-right">{{ headline_url.length }}/30</span>
                            </div>
                            </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="d-flex align-items-center">
                        <div class="w-100">
                            <span class="input-label">Add URL</span>
                            <div class="d-flex align-content-center mt-2">
                                <input type="text" name="add_url"  class="input-field input-width"  v-model="add_url" placeholder="Add URL" />
                            </div>
                            <div class="text-right mt-1">
                                <span class="input-field-length float-right">{{ add_url.length }}/50</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                        <div class="col-lg-8 col-md-8 col-sm-6">
                            <span class="input-label">
                                Start Date <sup class="fs-14 pl-1 text-danger">*</sup>
                            </span>
                            <div class="d-flex align-items-center mt-2">
                                <date-picker v-model="templateone_start_date" name="templateone_start_date"
                                    class="meetinfdatetime mx-left calendar-edit-per mr-1"
                                    format="MM/DD/YYYY" value-type="format" type="date" lang="en"
                                    :clearable="false" :editable="true" confirm confirm-text="APPLY">
                                </date-picker>
                            </div>
                            <span class="invalid-feedback-form text-danger" v-if="is_templateone_start_date">
                                Start Date is required.
                            </span>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 pl-1">
                            <span class="input-label">
                                Time <sup class="fs-14 pl-1 text-danger">*</sup>
                            </span>
                            <div class="d-flex align-items-center mt-2">
                                <date-picker v-model="templateone_start_time" name="templateone_start_time" v-validate="'required'" class="meetinfdatetime mx-left calendar-edit-per mr-1 calendar-down-arrow-grey hide-seconds date-picker-clock-svg-icon" format="hh:mm a" type="time" :minute-step="1" placeholder="HH:MM" value-type="format"  lang="en" :clearable="false" :editable="false" confirm confirm-text="APPLY"></date-picker>
                            </div>
                            <span class="invalid-feedback-form text-danger" v-if="is_templateone_start_date">Start Time is required.</span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="row">
                        <div class="col-lg-8 col-md-8 col-sm-6">
                            <span class="input-label">
                                End Date <sup class="fs-14 pl-1 text-danger">*</sup>
                            </span>
                            <div class="d-flex align-items-center mt-2">
                                <date-picker v-model="templateone_end_date" v-validate="'required'"
                                name="templateone_end_date" class="meetinfdatetime mx-left calendar-edit-per mr-1 calendar-edit-per mr-1 "
                                format="MM/DD/YYYY" value-type="format" type="date" lang="en"
                                :clearable="false"
                                :default-value="current_date"
                                :not-before="current_date"
                                :editable="false" confirm confirm-text="APPLY"></date-picker>
                            </div>
                            <span class="invalid-feedback-form text-danger" v-if="is_templateone_end_date"> End Date is required.</span>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 pl-1">
                            <span class="input-label">
                                Time  <sup class="fs-14 pl-1 text-danger">*</sup>
                            </span>
                            <div class="d-flex align-items-center mt-2">
                                <date-picker v-model="template_end_time" name="template_end_time" v-validate="'required'" class="meetinfdatetime mx-left calendar-edit-per mr-1 calendar-down-arrow-grey hide-seconds date-picker-clock-svg-icon" format="hh:mm a" type="time" :minute-step="1" placeholder="HH:MM" value-type="format"  lang="en"  :clearable="false" :editable="false" confirm confirm-text="APPLY"></date-picker>
                            </div>
                            <span class="invalid-feedback-form text-danger" v-if="is_template_end_time">
                                End Time is required.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-7">
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="d-flex align-items-center">
                        <div class="w-100">
                            <span class="input-label">Topic Name<sup class="fs-14 pl-1 text-danger">*</sup></span>
                            <div class="d-flex align-content-center mt-2">
                                <input type="text" name="topic_name" maxlength="30" class="input-field input-width" v-model="topic_name" placeholder="Add Topic" />
                            </div>
                            <div class="text-right mt-1">
                                <span class="input-field-length float-right">{{ topic_name.length }}/30</span>
                                <!-- <span class="float-left text-danger mb-3" v-show="errors.has('topic_name')">Topic Name is Required</span> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8 col-md-8 col-sm-12">
                    <div class="d-flex align-items-center">
                        <div class="w-100">
                            <span class="input-label">Topic Content<sup class="fs-14 pl-1 text-danger">*</sup></span>
                            <div class="d-flex align-content-center mt-2">
                                <input type="text" name="topic_content" maxlength="100" class="input-field input-width" v-model="topic_content" placeholder="Add Content" />
                            </div>
                            <div class="text-right mt-1">
                                <span class="input-field-length float-right">{{ topic_content.length }}/100</span>
                                <!-- <span class="float-left text-danger mb-3" v-show="errors.has('topic_content')">Topic Content is Required</span> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-5">
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="d-flex align-items-center">
                        <div class="w-100">
                            <span class="input-label">Headline Name<sup class="fs-14 pl-1 text-danger">*</sup></span>
                            <div class="d-flex align-content-center mt-2">
                                <input type="text" name="headline_name" maxlength="30" class="input-field input-width" v-model="headline_name" placeholder="Add Headline" />
                            </div>
                            <div class="text-right mt-1">
                                <span class="input-field-length float-right">{{ headline_name.length }}/30</span>
                                <!-- <span class="float-left text-danger mb-3" v-show="errors.has('headline_name')">Headline Name is Required</span> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8 col-md-8 col-sm-12">
                    <div class="d-flex align-items-center">
                        <div class="w-100">
                            <span class="input-label">Headline Content<sup class="fs-14 pl-1 text-danger">*</sup></span>
                            <div class="d-flex align-content-center mt-2">
                                <input type="text" name="headline_content" maxlength="100" class="input-field input-width" v-model="headline_content" placeholder="Add Content" />
                            </div>
                            <div class="text-right mt-1">
                                <span class="input-field-length float-right">{{ headline_content.length }}/100</span>
                                <!-- <span class="float-left text-danger mb-3" v-show="errors.has('headline_content')">Headline Content is Required</span> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-5">
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <span class="input-label">
                        Sub-Content 1
                    </span>
                    <div class="d-flex align-items-center mt-2">
                        <textarea-autosize class="digi-textarea white-background bordered" maxlength="100" placeholder="Enter Sub-Content 1" v-model="sub_content_one" style="height: 7em; overflow: auto;" />
                    </div>
                    <div class="text-right mt-1">
                        <span class="input-field-length float-right">{{ sub_content_one.length }}/100</span>
                        <!-- <span class="float-left text-danger mb-3" v-show="errors.has('sub_content_one')">Sub Content One is Required</span> -->
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <span class="input-label">
                        Sub-Content 2
                    </span>
                    <div class="d-flex align-items-center mt-2">
                        <textarea-autosize class="digi-textarea white-background bordered" maxlength="100" placeholder="Enter Sub-Content 2" v-model="sub_content_two" style="height: 7em; overflow: auto;" />
                    </div>
                    <div class="text-right mt-1">
                        <span class="input-field-length float-right">{{ sub_content_two.length }}/100</span>
                        <!-- <span class="float-left text-danger mb-3" v-show="errors.has('sub_content_two')">Sub Content Two is Required</span> -->
                    </div>
                </div>
            </div>

        </div>
        <div class="mt-6 px-17" >
            <div class="mt-5 w-100 h-line">
                <span class="bg-white h-label">Address Details</span>
            </div>
            <div class="row mt-7">
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="d-flex align-items-center">
                        <div class="form-group pt-2 gMap" style="width:180em;">
                            <gmap-autocomplete
                                class="input-white"
                                id="autocompleteInput"
                                name="get_location"
                                placeholder="Search Location"
                                @place_changed="setPlace"
                                :value="meeting_location_vmodel"
                                v-model="meeting_location_vmodel"
                                style="padding: 6px 32px 6px 12px !important;background-color: #eff3f9">
                            </gmap-autocomplete>
                            <el-tooltip class="item"
                                effect="dark"
                                :content="meeting_location_vmodel"
                                placement="top">
                                <img src="/static/images/images-new-theme/icons/marker_pin.svg"
                                    style="position: absolute;right: 12px;bottom: 10px;" />
                            </el-tooltip>
                        </div>
                        <div class="mt-1 ml-3" style="cursor: pointer;width:10%;" @click="getLocation">
                            <img src="/static/images/images-new-theme/icons/GPS 2.svg" style="height: 40px;" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="d-flex align-items-center">
                        <div class="w-100">
                            <span class="input-label">Address</span>
                            <div class="d-flex align-content-center mt-2">
                                <input type="text" name="address"  class="input-field input-width"  v-model="address" placeholder="Address" />
                            </div>
                            </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div>
                        <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600 ml-4">Country<sup class="fs-14 pl-1 text-danger">*</sup></span>
                        <div class="d-flex align-items-center">
                            <div class="w-100" >
                                <multiselect class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-2" name="country" :searchable="true" :options="countries"  v-validate="'required'" v-model="location.country" @select="resetData" placeholder="Select Country">
                                    <template slot="noOptions">
                                        <div class="text-secondary text-center fw-600">Countries Not Found</div>
                                    </template>
                                    <template slot="noResult">
                                        <div class="text-secondary text-center fw-600">No Results Found</div>
                                    </template>
                                </multiselect>
                                <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('country')">Country is required</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="d-flex align-items-center">
                        <div class="w-100">
                            <span class="input-label">State</span>
                            <div class="d-flex align-content-center mt-2">
                                <input type="text" name="state"  class="input-field input-width"  v-model="state" placeholder="State" />

                            </div>
                            </div>
                    </div>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="d-flex align-items-center">
                        <div class="w-100">
                            <span class="input-label">City</span>
                            <div class="d-flex align-content-center mt-2">
                                <input type="text" name="city"  class="input-field input-width"  v-model="city" placeholder="City" />
                            </div>
                            <div class="text-right mt-1">
                                <span class="input-field-length float-right">{{ city.length }}/15</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="d-flex align-items-center">
                        <div class="w-100">
                            <span class="input-label">Township</span>
                            <div class="d-flex align-content-center mt-2">
                                <input type="text" name="content"  class="input-field input-width"  v-model="township"  placeholder="Township" />
                            </div>
                            <div class="text-right mt-1">
                                <span class="input-field-length float-right">{{ township.length }}/15</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="d-flex align-items-center">
                        <div class="w-100">
                            <span class="input-label">Pincode</span>
                            <div class="d-flex align-content-center mt-2">
                                <input type="text" name="pincode"  class="input-field input-width"  v-model="pincode"  placeholder="Pincode" />
                            </div>
                            <div class="text-right mt-1">
                                <span class="input-field-length float-right">{{ pincode.length }}/10</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-6 px-17" >
            <div class="mt-5 w-100 h-line">
                <span class="bg-white h-label">Social Media URLs</span>
            </div>
            <div class="row mt-3">
                <div class="col-lg-3 col-md-3 col-sm-12">
                    <div class="d-flex align-items-center mt-2">
                        <input type="text" name="add_url"  class="input-field icon-data icon-face-link input-width"  v-model="add_url" placeholder="Add URL" />
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12">
                    <div class="d-flex align-items-center mt-2">
                        <input type="text" name="add_url"  class="input-field icon-data icon-twit-link input-width"  v-model="add_url" placeholder="Add URL" />
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12">
                    <div class="d-flex align-items-center mt-2">
                        <input type="text" name="add_url"  class="input-field icon-data icon-insta-link input-width"  v-model="add_url" placeholder="Add URL" />
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-12">
                    <div class="d-flex align-items-center mt-2 ">
                        <input type="text" name="add_url"  class="input-field icon-data icon-link input-width"  v-model="add_url" placeholder="Add URL" />
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-6 px-17" >
            <div class="mt-5 w-100 h-line">
                <span class="bg-white h-label">Add Images</span>
            </div>
            <div class="row mt-5">
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <div class="mt-5 col-md-offset-2 flex-width">
                        <div class="stage-sections">
                            <span class="bg-white fw-500">Logo</span>
                            <div class="overflow-auto mx-ht mt-3">
                                <div class="upload-main d-flex flex-column justify-content-center align-items-center pl-0 "
                                style="border: 3px dashed rgb(224, 224, 224);border-bottom-left-radius: 12px;border-bottom-right-radius: 12px;">
                                    <div class="px-12 mt-7 drag-drop-white-bg pt-2 pb-2 ml-4 mr-4">
                                        <p class="text-center fs-14 mb-0">
                                            <img src="/static/images/multimedia.svg" style="width:20px;" alt="">
                                            Drag and drop your files here <br>or<br>
                                            <file-upload class="choose-file btn fw-500 pl-0 pr-0 pointer"
                                                :multiple="false"
                                                :class="{'select-cursor': attachments.length >= 1}"
                                                :drop="true" :drop-directory="true"
                                                accept=".jpg, .png, .jpeg"
                                                @input-file="uploadAttachment" ref="upload"
                                                style="text-transform: none !important; color: #0475f3;width: 8em;">
                                                Browse
                                            </file-upload>
                                        </p>
                                    </div>
                                    <div class="pt-1 pb-1">
                                        <p class="drag_drop_cond text-center fs-14">
                                            Supports .jpg, .png, .jpeg. Size limit - 5.00 MB
                                        </p>
                                    </div>
                                </div>
                                <div class="p-4" v-for="(attachment,index) in attachments"  :key="attachment.url">
                                    <span  class="_images pointer" style="position: relative;" @click="previewImage(attachment)">
                                        <img v-if="attachment.url.endsWith('.svg')"
                                            src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                        <img class="icon-img" v-else-if="attachment.url.endsWith('.jpg')"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                        <img class="icon-img" v-else-if="attachment.url.endsWith('.png')"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/png-icon.svg" />
                                        <img class="icon-img" v-else-if="attachment.url.endsWith('.gif')"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/gif-icon.svg" />
                                        <img class="icon-img" v-else-if="attachment.url.endsWith('.jpeg')"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg-icon.svg" />
                                    </span>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <div class="d-flex align-items-center">
                                            <div>
                                                <img class="icon-img" v-if="attachment.name.endsWith('.jpg')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                                <img class="icon-img" v-else-if="attachment.name.endsWith('.png')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/png-icon.svg" />
                                                <img class="icon-img" v-else-if="attachment.name.endsWith('.gif')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/gif-icon.svg" />
                                                <img class="icon-img" v-else-if="attachment.name.endsWith('.jpeg')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg-icon.svg" />
                                                <img class="icon-img" v-else-if="attachment.name.endsWith('.svg')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/svg-icon.svg" />
                                            </div>
                                            <div class="col">
                                                <div class="d-flex justify-content-between">
                                                    <el-tooltip :content="attachment.name" placement="top">
                                                        <div
                                                            class="font-weight-bold text-truncate d-block mx-width-220">
                                                            {{attachment.name}}</div>
                                                    </el-tooltip>
                                                </div>
                                                <div v-if="attachment.uploading || attachment.url == undefined">
                                                    <progress-bar class="progressBar w-100"
                                                        :class="{'error-upload':attachment.url == undefined}"
                                                        :val="attachment.progress" size="small"></progress-bar>
                                                </div>
                                                <div class="d-flex justify-content-between">
                                                    <div class="text-danger pl-0 fw-500"
                                                        v-if="attachment.error != ''">{{attachment.error}}...
                                                    </div>
                                                    <div class="text-secondary fw-500"
                                                        v-if="attachment.progress<100 && attachment.error == ''">
                                                        {{attachment.progress}}% Uploaded</div>
                                                    <div class="fw-500">({{attachment.size | prettyBytes}})
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="attachment.uploading || attachment.url == undefined"
                                            class="pointer" @click="deleteAttachment(index)">
                                            <i class="icon icon-close fs-16 closeAttachment"></i>
                                        </div>
                                        <div v-else class="pointer" @click="deleteAttachment(index)">
                                            <i class="icon icon-close fs-16 closeAttachment"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <div class="mt-5 col-md-offset-2 flex-width">
                        <div class="stage-sections">
                            <span class="bg-white fw-500">Main Image</span>
                            <div class="overflow-auto mx-ht mt-3">
                                <div class="upload-main d-flex flex-column justify-content-center align-items-center pl-0 "
                                style="border: 3px dashed rgb(224, 224, 224);border-bottom-left-radius: 12px;border-bottom-right-radius: 12px;">
                                    <div class="px-12 mt-7 drag-drop-white-bg pt-2 pb-2 ml-4 mr-4">
                                        <p class="text-center fs-14 mb-0">
                                            <img src="/static/images/multimedia.svg" style="width:20px;" alt="">
                                            Drag and drop your files here or
                                            <file-upload class="choose-file btn fw-500 pl-0 pr-0 pointer"
                                                :multiple="false"
                                                :class="{'select-cursor': attachments.length >= 10}"
                                                :drop="true" :drop-directory="true"
                                                accept=".jpg, .png, .jpeg"
                                                @input-file="uploadAttachment" ref="upload"
                                                style="text-transform: none !important; color: #0475f3;width: 8em;">
                                                Browse
                                            </file-upload>
                                        </p>
                                    </div>
                                    <div class="pt-4 pb-4">
                                        <p class="drag_drop_cond text-center fs-14">
                                            Supports .jpg, .png, .jpeg. Size limit - 5.00 MB
                                        </p>
                                    </div>
                                </div>
                                <div class="p-4" v-for="(attachment,index) in attachments"
                                    :key="attachment.url">
                                    <span  class="_images pointer" style="position: relative;" @click="previewImage(attachment)">
                                        <img v-if="attachment.url.endsWith('.svg')"
                                            src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                        <img class="icon-img" v-if="attachment.url.endsWith('.jpg')"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                        <img class="icon-img" v-else-if="attachment.url.endsWith('.png')"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/png-icon.svg" />
                                        <img class="icon-img" v-else-if="attachment.url.endsWith('.gif')"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/gif-icon.svg" />
                                        <img class="icon-img" v-else-if="attachment.url.endsWith('.jpeg')"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg-icon.svg" />
                                    </span>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <div class="d-flex align-items-center">
                                            <div>
                                                <img class="icon-img" v-if="attachment.name.endsWith('.jpg')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                                <img class="icon-img" v-else-if="attachment.name.endsWith('.png')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/png-icon.svg" />
                                                <img class="icon-img" v-else-if="attachment.name.endsWith('.gif')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/gif-icon.svg" />
                                                <img class="icon-img" v-else-if="attachment.name.endsWith('.jpeg')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg-icon.svg" />
                                                <img class="icon-img" v-else-if="attachment.name.endsWith('.svg')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/svg-icon.svg" />
                                            </div>
                                            <div class="col">
                                                <div class="d-flex justify-content-between">
                                                    <el-tooltip :content="attachment.name" placement="top">
                                                        <div
                                                            class="font-weight-bold text-truncate d-block mx-width-220">
                                                            {{attachment.name}}</div>
                                                    </el-tooltip>
                                                </div>
                                                <div v-if="attachment.uploading || attachment.url == undefined">
                                                    <progress-bar class="progressBar w-100"
                                                        :class="{'error-upload':attachment.url == undefined}"
                                                        :val="attachment.progress" size="small"></progress-bar>
                                                </div>
                                                <div class="d-flex justify-content-between">
                                                    <div class="text-danger pl-0 fw-500"
                                                        v-if="attachment.error != ''">{{attachment.error}}...
                                                    </div>
                                                    <div class="text-secondary fw-500"
                                                        v-if="attachment.progress<100 && attachment.error == ''">
                                                        {{attachment.progress}}% Uploaded</div>
                                                    <div class="fw-500">({{attachment.size | prettyBytes}})
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="attachment.uploading || attachment.url == undefined"
                                            class="pointer" @click="deleteAttachment(index)">
                                            <i class="icon icon-close fs-16 closeAttachment"></i>
                                        </div>
                                        <div v-else class="pointer" @click="deleteAttachment(index)">
                                            <i class="icon icon-close fs-16 closeAttachment"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <div class="mt-5 col-md-offset-2 flex-width">
                        <div class="stage-sections">
                            <span class="bg-white fw-500">Content Image 1</span>
                            <div class="overflow-auto mx-ht mt-3">
                                <div class="upload-main d-flex flex-column justify-content-center align-items-center pl-0 "
                                style="border: 3px dashed rgb(224, 224, 224);border-bottom-left-radius: 12px;border-bottom-right-radius: 12px;">
                                    <div class="px-12 mt-7 drag-drop-white-bg pt-2 pb-2 ml-4 mr-4">
                                        <p class="text-center fs-14 mb-0">
                                            <img src="/static/images/multimedia.svg" style="width:20px;" alt="">
                                            Drag and drop your files here or
                                            <file-upload class="choose-file btn fw-500 pl-0 pr-0 pointer"
                                                :multiple="false"
                                                :class="{'select-cursor': attachments.length >= 10}"
                                                :drop="true" :drop-directory="true"
                                                accept=".jpg, .png, .jpeg"
                                                @input-file="uploadAttachment" ref="upload"
                                                style="text-transform: none !important; color: #0475f3;width: 8em;">
                                                Browse
                                            </file-upload>
                                        </p>
                                    </div>
                                    <div class="pt-4 pb-4">
                                        <p class="drag_drop_cond text-center fs-14">
                                            Supports .jpg, .png, .jpeg. Size limit - 5.00 MB
                                        </p>
                                    </div>
                                </div>
                                <div class="p-4" v-for="(attachment,index) in attachments"
                                    :key="attachment.url">
                                    <span  class="_images pointer" style="position: relative;" @click="previewImage(attachment)">
                                        <img v-if="attachment.url.endsWith('.svg')"
                                            src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                        <img class="icon-img" v-if="attachment.url.endsWith('.jpg')"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                        <img class="icon-img" v-else-if="attachment.url.endsWith('.png')"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/png-icon.svg" />
                                        <img class="icon-img" v-else-if="attachment.url.endsWith('.gif')"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/gif-icon.svg" />
                                        <img class="icon-img" v-else-if="attachment.url.endsWith('.jpeg')"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg-icon.svg" />
                                    </span>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <div class="d-flex align-items-center">
                                            <div>
                                                <img class="icon-img" v-if="attachment.name.endsWith('.jpg')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                                <img class="icon-img" v-else-if="attachment.name.endsWith('.png')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/png-icon.svg" />
                                                <img class="icon-img" v-else-if="attachment.name.endsWith('.gif')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/gif-icon.svg" />
                                                <img class="icon-img" v-else-if="attachment.name.endsWith('.jpeg')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg-icon.svg" />
                                                <img class="icon-img" v-else-if="attachment.name.endsWith('.svg')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/svg-icon.svg" />
                                            </div>
                                            <div class="col">
                                                <div class="d-flex justify-content-between">
                                                    <el-tooltip :content="attachment.name" placement="top">
                                                        <div
                                                            class="font-weight-bold text-truncate d-block mx-width-220">
                                                            {{attachment.name}}</div>
                                                    </el-tooltip>
                                                </div>
                                                <div v-if="attachment.uploading || attachment.url == undefined">
                                                    <progress-bar class="progressBar w-100"
                                                        :class="{'error-upload':attachment.url == undefined}"
                                                        :val="attachment.progress" size="small"></progress-bar>
                                                </div>
                                                <div class="d-flex justify-content-between">
                                                    <div class="text-danger pl-0 fw-500"
                                                        v-if="attachment.error != ''">{{attachment.error}}...
                                                    </div>
                                                    <div class="text-secondary fw-500"
                                                        v-if="attachment.progress<100 && attachment.error == ''">
                                                        {{attachment.progress}}% Uploaded</div>
                                                    <div class="fw-500">({{attachment.size | prettyBytes}})
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="attachment.uploading || attachment.url == undefined"
                                            class="pointer" @click="deleteAttachment(index)">
                                            <i class="icon icon-close fs-16 closeAttachment"></i>
                                        </div>
                                        <div v-else class="pointer" @click="deleteAttachment(index)">
                                            <i class="icon icon-close fs-16 closeAttachment"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <div class="mt-5 col-md-offset-2 flex-width">
                        <div class="stage-sections">
                            <span class="bg-white fw-500">Content Image 2</span>
                            <div class="overflow-auto mx-ht mt-3">
                                <div class="upload-main d-flex flex-column justify-content-center align-items-center pl-0 "
                                style="border: 3px dashed rgb(224, 224, 224);border-bottom-left-radius: 12px;border-bottom-right-radius: 12px;">
                                    <div class="px-12 mt-7 drag-drop-white-bg pt-2 pb-2 ml-4 mr-4">
                                        <p class="text-center fs-14 mb-0">
                                        <img src="/static/images/multimedia.svg" style="width:20px;" alt="">
                                        Drag and drop your files here or
                                        <file-upload class="choose-file btn fw-500 pl-0 pr-0 pointer"
                                            :multiple="false"
                                            :class="{'select-cursor': attachments.length >= 1}"
                                            :drop="true" :drop-directory="true"
                                            accept=".jpg, .png, .jpeg"
                                            @input-file="uploadAttachment" ref="upload"
                                            style="text-transform: none !important; color: #0475f3;width: 8em;">
                                            Browse
                                        </file-upload>
                                        </p>
                                    </div>
                                    <div class="pt-4 pb-4">
                                        <p class="drag_drop_cond text-center fs-14">
                                            Supports .jpg, .png, .jpeg. Size limit - 5.00 MB
                                        </p>
                                    </div>
                                </div>
                                <div class="p-4" v-for="(attachment,index) in attachments"  :key="attachment.url">
                                    <span  class="_images pointer" style="position: relative;" @click="previewImage(attachment)">
                                        <img v-if="attachment.url.endsWith('.svg')"
                                            src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                        <img class="icon-img" v-else-if="attachment.url.endsWith('.jpg')"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                        <img class="icon-img" v-else-if="attachment.url.endsWith('.png')"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/png-icon.svg" />
                                        <img class="icon-img" v-else-if="attachment.url.endsWith('.gif')"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/gif-icon.svg" />
                                        <img class="icon-img" v-else-if="attachment.url.endsWith('.jpeg')"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg-icon.svg" />
                                    </span>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <div class="d-flex align-items-center">
                                            <div>
                                                <img class="icon-img" v-if="attachment.name.endsWith('.jpg')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                                <img class="icon-img" v-else-if="attachment.name.endsWith('.png')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/png-icon.svg" />
                                                <img class="icon-img" v-else-if="attachment.name.endsWith('.gif')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/gif-icon.svg" />
                                                <img class="icon-img" v-else-if="attachment.name.endsWith('.jpeg')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg-icon.svg" />
                                                <img class="icon-img" v-else-if="attachment.name.endsWith('.svg')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/svg-icon.svg" />
                                            </div>
                                            <div class="col">
                                                <div class="d-flex justify-content-between">
                                                    <el-tooltip :content="attachment.name" placement="top">
                                                        <div
                                                            class="font-weight-bold text-truncate d-block mx-width-220">
                                                            {{attachment.name}}</div>
                                                    </el-tooltip>
                                                </div>
                                                <div v-if="attachment.uploading || attachment.url == undefined">
                                                    <progress-bar class="progressBar w-100"
                                                        :class="{'error-upload':attachment.url == undefined}"
                                                        :val="attachment.progress" size="small"></progress-bar>
                                                </div>
                                                <div class="d-flex justify-content-between">
                                                    <div class="text-danger pl-0 fw-500"
                                                        v-if="attachment.error != ''">{{attachment.error}}...
                                                    </div>
                                                    <div class="text-secondary fw-500"
                                                        v-if="attachment.progress<100 && attachment.error == ''">
                                                        {{attachment.progress}}% Uploaded</div>
                                                    <div class="fw-500">({{attachment.size | prettyBytes}})
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="attachment.uploading || attachment.url == undefined"
                                            class="pointer" @click="deleteAttachment(index)">
                                            <i class="icon icon-close fs-16 closeAttachment"></i>
                                        </div>
                                        <div v-else class="pointer" @click="deleteAttachment(index)">
                                            <i class="icon icon-close fs-16 closeAttachment"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <div class="mt-5 col-md-offset-2 flex-width">
                        <div class="stage-sections">
                            <span class="bg-white fw-500">Contant Image 3</span>
                            <div class="overflow-auto mx-ht mt-3">
                                <div class="upload-main d-flex flex-column justify-content-center align-items-center pl-0 "
                                style="border: 3px dashed rgb(224, 224, 224);border-bottom-left-radius: 12px;border-bottom-right-radius: 12px;">
                                    <div class="px-12 mt-7 drag-drop-white-bg pt-2 pb-2 ml-4 mr-4">
                                        <p class="text-center fs-14 mb-0">
                                            <img src="/static/images/multimedia.svg" style="width:20px;" alt="">
                                            Drag and drop your files here or
                                            <file-upload class="choose-file btn fw-500 pl-0 pr-0 pointer"
                                                :multiple="false"
                                                :class="{'select-cursor': attachments.length >= 10}"
                                                :drop="true" :drop-directory="true"
                                                accept=".jpg, .png, .jpeg"
                                                @input-file="uploadAttachment" ref="upload"
                                                style="text-transform: none !important; color: #0475f3;width: 8em;">
                                                Browse
                                            </file-upload>
                                        </p>
                                    </div>
                                    <div class="pt-4 pb-4">
                                        <p class="drag_drop_cond text-center fs-14">
                                            Supports .jpg, .png, .jpeg. Size limit - 5.00 MB
                                        </p>
                                    </div>
                                </div>
                                <div class="p-4" v-for="(attachment,index) in attachments"
                                    :key="attachment.url">
                                    <span  class="_images pointer" style="position: relative;" @click="previewImage(attachment)">
                                        <img v-if="attachment.url.endsWith('.svg')"
                                            src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg" />
                                        <img class="icon-img" v-if="attachment.url.endsWith('.jpg')"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                        <img class="icon-img" v-else-if="attachment.url.endsWith('.png')"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/png-icon.svg" />
                                        <img class="icon-img" v-else-if="attachment.url.endsWith('.gif')"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/gif-icon.svg" />
                                        <img class="icon-img" v-else-if="attachment.url.endsWith('.jpeg')"
                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg-icon.svg" />
                                    </span>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <div class="d-flex align-items-center">
                                            <div>
                                                <img class="icon-img" v-if="attachment.name.endsWith('.jpg')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                                <img class="icon-img" v-else-if="attachment.name.endsWith('.png')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/png-icon.svg" />
                                                <img class="icon-img" v-else-if="attachment.name.endsWith('.gif')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/gif-icon.svg" />
                                                <img class="icon-img" v-else-if="attachment.name.endsWith('.jpeg')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg-icon.svg" />
                                                <img class="icon-img" v-else-if="attachment.name.endsWith('.svg')"
                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/svg-icon.svg" />
                                            </div>
                                            <div class="col">
                                                <div class="d-flex justify-content-between">
                                                    <el-tooltip :content="attachment.name" placement="top">
                                                        <div
                                                            class="font-weight-bold text-truncate d-block mx-width-220">
                                                            {{attachment.name}}</div>
                                                    </el-tooltip>
                                                </div>
                                                <div v-if="attachment.uploading || attachment.url == undefined">
                                                    <progress-bar class="progressBar w-100"
                                                        :class="{'error-upload':attachment.url == undefined}"
                                                        :val="attachment.progress" size="small"></progress-bar>
                                                </div>
                                                <div class="d-flex justify-content-between">
                                                    <div class="text-danger pl-0 fw-500"
                                                        v-if="attachment.error != ''">{{attachment.error}}...
                                                    </div>
                                                    <div class="text-secondary fw-500"
                                                        v-if="attachment.progress<100 && attachment.error == ''">
                                                        {{attachment.progress}}% Uploaded</div>
                                                    <div class="fw-500">({{attachment.size | prettyBytes}})
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="attachment.uploading || attachment.url == undefined"
                                            class="pointer" @click="deleteAttachment(index)">
                                            <i class="icon icon-close fs-16 closeAttachment"></i>
                                        </div>
                                        <div v-else class="pointer" @click="deleteAttachment(index)">
                                            <i class="icon icon-close fs-16 closeAttachment"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import countries from "../../json/countries.json";
    import axios from "axios";
    import { EventBus } from '../../eventBus/nav-bar-event';
    export default {
        data(){
            return {
                ajaxCallInProgress: false,
                countries: countries,
                location:{
                    full_address: "",
                    address_type: "mailing_address",
                    address_description: "primary",
                    street:'',
                    city:'',
                    township:'',
                    country:'',
                    zip_code:'',
                    latitude:'',
                    longitude:'',

                },
                images: {
                    url: "https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images//product-access-icon-default-blue.svg",
                    icon: "https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg",
                    name: "radioImg"
                },
                attachments: [],
                add_url:'',
                pincode:'',
                township:'',
                city:'',
                state:'',
                address:'',
                meeting_location_vmodel: "",
                content:'',
                headline:'',
                headline_url:'',
                countries: countries,
                address:'',
                product_name:'',
                recipient_details: [],
                isVisible: false,
                is_templateone_start_date: false,
                is_template_end_time:false,
                templateone_start_date: moment(new Date().toUTCString()).format("MM/DD/YYYY"),
                templateone_end_date: '',
                templateone_start_time: moment(new Date().toUTCString()).format("LT"),
                template_end_time: '',
                is_templateone_end_date: false,
                topic_name: '',
                topic_content: '',
                headline_name: '',
                headline_content: '',
                sub_content_one: '',
                sub_content_two: '',
                sub_content_three: '',
            }
        },
        components:{
        },
        methods:{
            resetData(){
                this.location.state = '',
                this.location.city = '',
                this.location.township = '',
                this.location.zip_code = '',
                this.location.full_address = '',
                this.location.street = ''
                this.location.building_no = ''
                this.location.country = ''
            },
            setPlace(place) {
                this.meeting_location_vmodel = place.formatted_address;
                this.showAddress = true;
                let currentPlace = place;
                let address = place.formatted_address.split(", ");
                this.createJson.meeting_location.street =
                    address[address.length - 4] || "";
                this.createJson.meeting_location.township =
                    address[address.length - 3] || "";
                this.createJson.meeting_location.city = address[address.length - 3] || "";
                let statezip = address[address.length - 2] ?
                    address[address.length - 2].split(" ") : ["", ""];
                if (address[address.length - 1].includes("-")) {
                    let countrySelected = address[address.length - 1].split(" - ");
                    countrySelected.forEach(x => {
                        if (this.countries.includes(x)) {
                            this.createJson.meeting_location.country = x;
                        } else {
                            this.createJson.meeting_location.country = "";
                        }
                    });
                } else {
                    this.createJson.meeting_location.country = address[address.length - 1];
                }
                this.createJson.meeting_location.state = statezip[0].match(/^[a-zA-Z]+$/) ?
                    statezip[0] :
                    statezip[1].match(/^[a-zA-Z]+$/) ?
                    statezip[1] :
                    "";
                this.createJson.meeting_location.zip_code = statezip[0].match(/^[0-9]+$/) ?
                    statezip[0] :
                    statezip[1].match(/^[0-9]+$/) ?
                    statezip[1] :
                    "";
                // this.createJson.meeting_location.latitude = currentPlace.geometry.location.lat();
                // this.createJson.meeting_location.longitude = currentPlace.geometry.location.lng();
            },
            getLocation() {
                if (navigator.geolocation) {
                    // timeout at 60000 milliseconds (60 seconds)
                    var options = {
                        enableHighAccuracy: false,
                        timeout: 30000, // milliseconds (30 seconds)
                        maximumAge: 600000
                    }; // milliseconds (10 minutes)
                    navigator.geolocation.getCurrentPosition(
                        this.showLocation,
                        this.errorHandler,
                        options
                    );
                } else {
                    alert("Sorry, browser does not support geolocation");
                }
            },
            uploadAttachment(newFile, oldFile) {
                var input = newFile;
                if(this.attachments.map(x => x.name).includes(input.file.name)){
                    this.$toasted.global.error("This file already exists")
                } else if(!input.file.name.endsWith('.htm') && !input.file.name.endsWith('.html') && !input.file.name.endsWith('.flv')){
                    this.total_file_size = this.total_file_size + input.file.size
                    if (input.file) {
                        const CancelToken = axios.CancelToken;
                        const source = CancelToken.source();
                        let attachment = {
                            name: input.file.name,
                            size: JSON.stringify(input.file.size),
                            source: source,
                            progress: 0,
                            created_time: new Date(),
                            error: ""
                        }
                        if (this.attachments.length >= 1) {
                            this.$toasted.global.error("you're not allowed to upload more than 1 attachments")
                            this.total_file_size = this.total_file_size - input.file.size
                        } else if (this.total_file_size > 25000 * 1000){
                            this.$toasted.global.error("Attachments Size Cannot Exceed 25mb")
                            this.total_file_size = this.total_file_size - input.file.size
                        } else {
                            this.attachments.push(attachment);
                            this.getResumableURL(input.file, this.attachments[this.attachments.length - 1]);
                        }
                    }
                } else {
                    this.$toasted.global.error('This file is not supported')
                }
            },
            getResumableURL(file, attachment) {
                this.isUploadingInProgress = true;
                attachment.uploading = true;
                let data = {
                    file: attachment.name
                }
                data = new FormData()
                data.append('file', file)
                this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data, {
                        onUploadProgress: function (progressEvent) {
                            let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent
                                .total));
                            if (progress < 100) {
                                attachment.progress = progress;
                            }
                        }.bind(this)
                    })
                    .then(response => {
                        let resumable_url = response.data.url;
                        attachment.url = resumable_url;
                        attachment.progress = 100;
                        attachment.uploading = false;
                        this.isUploadingInProgress = false;
                        delete attachment['source'];
                        setTimeout(() => {
                            // this.saveFiles();
                        }, 500);
                    })
                    .catch(error => {
                        // console.log(error.data.reason)
                    })
            },
        },
        mounted(){
            EventBus.$on("call_template1", (mainData) => {
                this.$validator.validateAll().then(result => {
                })
            })
        },
        computed: {
            loggedInUser() {
                return this.$store.state.loggedInUser;
            },
            current_date() {
                var date = new Date();
                date.setDate(date.getDate() + 1);
                return date;
            },
        },
        created() {
        },
    }
</script>
<style scoped>

    .add-new-field{
        background-color: transparent;
        outline: 0 none !important;
    }
    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .create-company-container {
        background-color: #fff;
        padding: 0px 0 0px 0;
        border-radius: 5px;
    }

    .create-company-header {
        padding: 9.9px 15px;
        background-color: #00448b;
    }
    .input-label {
        font-weight: 600;
        line-height: 1.5;
        letter-spacing: 0.39px;
        text-align: left;
        color: #005dae;
        padding: 0 0 6px 12px;
        font-size: 14px;
    }
    .input-field {
        border-radius: 6px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px;
    }
    .input-width {
        border-radius: 5px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px !important;
    }
    .v-hidden {
        visibility: hidden;
    }

    i,
    [class^="icon-"] {
        line-height: 0px !important;
    }
    .text-green {
        color: #008a63 !important;
    }
    .pointer-event {
        background-color: #fff !important;
    }
    .text-secondary {
        color: #00448b !important;
    }
    .h-label{
        padding-right:10px;
        font-weight: 600;
        line-height: 1.5;
        letter-spacing: 0.39px;
        text-align: left;
        color: #005dae;
        font-size: 14px;
    }
    .h-line{
        height: 12px;
        border-bottom: 2px solid #ccc;
        text-align: left
    }
    .icon-data{
        padding-left: 30px;
        background-size: 20px !important;
        background-position: 2% 42% !important;
        font-family: 'Poppins', sans-serif !important;
    }
    .icon-face-link {
        background: url("https://storage.googleapis.com/5e8dbf9ac9ece9d5bf0786f0/598b84ab-f2be-40a0-a1d6-bed8c747a012.png") no-repeat left;
    }
    .icon-insta-link {
        background: url("https://storage.googleapis.com/5e8dbf9ac9ece9d5bf0786f0/efb3d282-9581-4712-9bd8-e897eadec524.png") no-repeat left;
    }
    .icon-twit-link {
        background: url("https://storage.googleapis.com/5e8dbf9ac9ece9d5bf0786f0/07397637-cd28-4f17-8e55-b1a233a0613e.png") no-repeat left;
    }
    .icon-link {
        background: url("https://storage.googleapis.com/5e8dbf9ac9ece9d5bf0786f0/68ed13c1-1fae-4803-b032-7feec568de10.png") no-repeat left;
    }
    .img {
        opacity: 1;
        display: block;
        width: 100%;
        height: auto;
        transition: .5s ease;
        backface-visibility: hidden;
    }
    .middle {
        transition: .5s ease;
        opacity: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        text-align: center;
    }
    .icon-css{
        color:#000;
        width:27px !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/Campaign/Email/EmailTemplateOne.vue